import * as ambassadorWixDataV1DataPermissions from './data-v1-data-permissions-permissions.http.js';
import * as ambassadorWixDataV1DataPermissionsTypes from './data-v1-data-permissions-permissions.types.js';
import * as ambassadorWixDataV1DataPermissionsUniversalTypes from './data-v1-data-permissions-permissions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getPermissions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV1DataPermissionsUniversalTypes.GetPermissionsRequest,
  ambassadorWixDataV1DataPermissionsTypes.GetPermissionsRequest,
  ambassadorWixDataV1DataPermissionsUniversalTypes.GetPermissionsResponse,
  ambassadorWixDataV1DataPermissionsTypes.GetPermissionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataPermissions.getPermissions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/permissions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePermissions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataPermissionsUniversalTypes.UpdatePermissionsRequest,
  ambassadorWixDataV1DataPermissionsTypes.UpdatePermissionsRequest,
  ambassadorWixDataV1DataPermissionsUniversalTypes.UpdatePermissionsResponse,
  ambassadorWixDataV1DataPermissionsTypes.UpdatePermissionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataPermissions.updatePermissions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/permissions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addSpecialPermissions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataPermissionsUniversalTypes.AddSpecialPermissionsRequest,
  ambassadorWixDataV1DataPermissionsTypes.AddSpecialPermissionsRequest,
  ambassadorWixDataV1DataPermissionsUniversalTypes.AddSpecialPermissionsResponse,
  ambassadorWixDataV1DataPermissionsTypes.AddSpecialPermissionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataPermissions.addSpecialPermissions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/permissions/special',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateSpecialPermissions(): __PublicMethodMetaInfo<
  'POST',
  { specialPermissionsId: string },
  ambassadorWixDataV1DataPermissionsUniversalTypes.UpdateSpecialPermissionsRequest,
  ambassadorWixDataV1DataPermissionsTypes.UpdateSpecialPermissionsRequest,
  ambassadorWixDataV1DataPermissionsUniversalTypes.UpdateSpecialPermissionsResponse,
  ambassadorWixDataV1DataPermissionsTypes.UpdateSpecialPermissionsResponse
> {
  const payload = {
    specialPermissions: { id: ':specialPermissionsId' },
  } as any;

  const getRequestOptions =
    ambassadorWixDataV1DataPermissions.updateSpecialPermissions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/permissions/special/{specialPermissions.id}',
    pathParams: { specialPermissionsId: 'specialPermissionsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeSpecialPermissions(): __PublicMethodMetaInfo<
  'DELETE',
  { specialPermissionsId: string },
  ambassadorWixDataV1DataPermissionsUniversalTypes.RemoveSpecialPermissionsRequest,
  ambassadorWixDataV1DataPermissionsTypes.RemoveSpecialPermissionsRequest,
  ambassadorWixDataV1DataPermissionsUniversalTypes.RemoveSpecialPermissionsResponse,
  ambassadorWixDataV1DataPermissionsTypes.RemoveSpecialPermissionsResponse
> {
  const payload = { specialPermissionsId: ':specialPermissionsId' } as any;

  const getRequestOptions =
    ambassadorWixDataV1DataPermissions.removeSpecialPermissions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/permissions/special/{specialPermissionsId}',
    pathParams: { specialPermissionsId: 'specialPermissionsId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMyPermissions(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV1DataPermissionsUniversalTypes.GetMyPermissionsRequest,
  ambassadorWixDataV1DataPermissionsTypes.GetMyPermissionsRequest,
  ambassadorWixDataV1DataPermissionsUniversalTypes.GetMyPermissionsResponse,
  ambassadorWixDataV1DataPermissionsTypes.GetMyPermissionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataPermissions.getMyPermissions(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/permissions/current',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  DataPermissions as DataPermissionsOriginal,
  AccessLevel as AccessLevelOriginal,
  AccessLevelWithLiterals as AccessLevelWithLiteralsOriginal,
  SpecialPermissions as SpecialPermissionsOriginal,
  SpecialPermissionsSubjectOneOf as SpecialPermissionsSubjectOneOfOriginal,
  Access as AccessOriginal,
  AccessWithLiterals as AccessWithLiteralsOriginal,
  SpecialPermissionsDraftItemsPluginPermissions as SpecialPermissionsDraftItemsPluginPermissionsOriginal,
  DraftItemsPluginPermissions as DraftItemsPluginPermissionsOriginal,
  GetPermissionsRequest as GetPermissionsRequestOriginal,
  GetPermissionsResponse as GetPermissionsResponseOriginal,
  UpdatePermissionsRequest as UpdatePermissionsRequestOriginal,
  UpdatePermissionsResponse as UpdatePermissionsResponseOriginal,
  AddSpecialPermissionsRequest as AddSpecialPermissionsRequestOriginal,
  AddSpecialPermissionsResponse as AddSpecialPermissionsResponseOriginal,
  UpdateSpecialPermissionsRequest as UpdateSpecialPermissionsRequestOriginal,
  UpdateSpecialPermissionsResponse as UpdateSpecialPermissionsResponseOriginal,
  RemoveSpecialPermissionsRequest as RemoveSpecialPermissionsRequestOriginal,
  RemoveSpecialPermissionsResponse as RemoveSpecialPermissionsResponseOriginal,
  GetMyPermissionsRequest as GetMyPermissionsRequestOriginal,
  GetMyPermissionsResponse as GetMyPermissionsResponseOriginal,
  GetMyPermissionsResponseDraftItemsPluginPermissions as GetMyPermissionsResponseDraftItemsPluginPermissionsOriginal,
  MigrateCustomRolesRequest as MigrateCustomRolesRequestOriginal,
  MigrateCustomRolesResponse as MigrateCustomRolesResponseOriginal,
  PolicyAssignmentsUpdated as PolicyAssignmentsUpdatedOriginal,
  PolicyAssignmentsUpdatedEventOneOf as PolicyAssignmentsUpdatedEventOneOfOriginal,
  PolicyAssigned as PolicyAssignedOriginal,
  Subject as SubjectOriginal,
  SubjectType as SubjectTypeOriginal,
  SubjectTypeWithLiterals as SubjectTypeWithLiteralsOriginal,
  SubjectContext as SubjectContextOriginal,
  SubjectContextType as SubjectContextTypeOriginal,
  SubjectContextTypeWithLiterals as SubjectContextTypeWithLiteralsOriginal,
  PolicyAssignment as PolicyAssignmentOriginal,
  ResourcePath as ResourcePathOriginal,
  Resource as ResourceOriginal,
  PolicyCondition as PolicyConditionOriginal,
  ConditionType as ConditionTypeOriginal,
  ConditionTypeOfOneOf as ConditionTypeOfOneOfOriginal,
  SimpleCondition as SimpleConditionOriginal,
  SimpleConditionValue as SimpleConditionValueOriginal,
  SimpleConditionValueValueOneOf as SimpleConditionValueValueOneOfOriginal,
  SimpleConditionOperator as SimpleConditionOperatorOriginal,
  SimpleConditionOperatorWithLiterals as SimpleConditionOperatorWithLiteralsOriginal,
  JoinedCondition as JoinedConditionOriginal,
  JoinedConditionOperator as JoinedConditionOperatorOriginal,
  JoinedConditionOperatorWithLiterals as JoinedConditionOperatorWithLiteralsOriginal,
  EnvironmentCondition as EnvironmentConditionOriginal,
  EnvironmentConditionConditionOneOf as EnvironmentConditionConditionOneOfOriginal,
  ExperimentCondition as ExperimentConditionOriginal,
  Condition as ConditionOriginal,
  ConditionOperator as ConditionOperatorOriginal,
  ConditionOperatorOperatorsOneOf as ConditionOperatorOperatorsOneOfOriginal,
  EqualOperator as EqualOperatorOriginal,
  ConditionValue as ConditionValueOriginal,
  ConditionValueValueOneOf as ConditionValueValueOneOfOriginal,
  LikeOperator as LikeOperatorOriginal,
  ExperimentOperator as ExperimentOperatorOriginal,
  DependOnOperator as DependOnOperatorOriginal,
  PolicyUnassigned as PolicyUnassignedOriginal,
  PolicyAssignmentUpdated as PolicyAssignmentUpdatedOriginal,
  Empty as EmptyOriginal,
  PolicyAuthorizationDataUpdated as PolicyAuthorizationDataUpdatedOriginal,
  PolicyStatement as PolicyStatementOriginal,
  Effect as EffectOriginal,
  EffectWithLiterals as EffectWithLiteralsOriginal,
  PolicyType as PolicyTypeOriginal,
  PolicyTypeWithLiterals as PolicyTypeWithLiteralsOriginal,
  PolicyOwner as PolicyOwnerOriginal,
  PolicyOwnerType as PolicyOwnerTypeOriginal,
  PolicyOwnerTypeWithLiterals as PolicyOwnerTypeWithLiteralsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  GetPermissionsApplicationErrors as GetPermissionsApplicationErrorsOriginal,
  UpdatePermissionsApplicationErrors as UpdatePermissionsApplicationErrorsOriginal,
  AddSpecialPermissionsApplicationErrors as AddSpecialPermissionsApplicationErrorsOriginal,
  UpdateSpecialPermissionsApplicationErrors as UpdateSpecialPermissionsApplicationErrorsOriginal,
  RemoveSpecialPermissionsApplicationErrors as RemoveSpecialPermissionsApplicationErrorsOriginal,
  GetMyPermissionsApplicationErrors as GetMyPermissionsApplicationErrorsOriginal,
} from './data-v1-data-permissions-permissions.types.js';
